<div class="categories">
  <div class="content-max-width">
    <ul class="list-categories" #listCategoriesBox>
      <li
        [id]="staticCategory.All"
        class="category-item is-active"
        [ngClass]="{
          'is-active': giftcardCategoryV2Service.selectedCategoryId === staticCategory.All
        }"
        (click)="toggleActive(staticCategory.All)"
      >
        <span>
          All
        </span>
      </li>
      <li
        *ngIf="shouldShowZipMoneyOnlyDealsCategory"
        [id]="staticCategory.ZipMoneyDeals"
        class="category-item"
        [ngClass]="{
          'is-active': giftcardCategoryV2Service.selectedCategoryId === staticCategory.ZipMoneyDeals
        }"
        (click)="toggleActive(staticCategory.ZipMoneyDeals)"
      >
        <span>
          Zip Money Deals
        </span>
      </li>
      <li
        *ngIf="shouldShowOtherDealsCategory"
        [id]="staticCategory.OtherDeals"
        class="category-item"
        [ngClass]="{
          'is-active': giftcardCategoryV2Service.selectedCategoryId === staticCategory.OtherDeals
        }"
        (click)="toggleActive(staticCategory.OtherDeals)"
      >
        <span>
          Deals
        </span>
      </li>
      <li
        [id]="category.id"
        class="category-item"
        [ngClass]="{ 'is-active': giftcardCategoryV2Service.selectedCategoryId === category.id }"
        *ngFor="let category of giftcardCategoryV2Service.giftcardCategories"
        (click)="toggleActive(category.id)"
      >
        <span>
          {{ category.name }}
        </span>
      </li>
    </ul>
  </div>
</div>
